// extracted by mini-css-extract-plugin
export var buttonContent = "_3q-0";
export var centered = "_3q-1";
export var centeredFlex = "_3q-2";
export var errorText = "_3q-3";
export var icon = "_3q-4";
export var iconButtonContent = "_3q-5";
export var monospace = "_3q-6";
export var padded = "_3q-7";